import axios from 'axios'
import { message } from 'ant-design-vue'
import VueCookies from 'vue-cookies'
import router from '../router'

const service = axios.create({
  // 线上正式版本
  baseURL: 'https://app.hobolite.com',
  // 线上测试版本
  // baseURL: 'http://47.94.205.49',
  // 线上内部版本
  // baseURL: 'https://sp.dev.jiehe-it.cn:12443',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

service.interceptors.request.use(config => {
  const token = VueCookies.get('token')
  if (token) {
    config.headers.token = token
  }
  return config
})

service.interceptors.response.use(response => {
  if (response.data.code === 200) {
    return response.data.data || {}
  } else if (response.data.code === 20003 || response.data.code === 20001) {
    message.warning('用户登录失效，请重新登录')
    VueCookies.remove('token')
    setTimeout(() => {
      router.push('/login')
    }, 1000)
  } else {
    message.info(response.data.message)
    return {
      isSuccess: 1
    }
  }
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js